import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TreeLink } from '@rivethealth/data/options';
import { ObservableInput } from 'observable-input';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'tree-multi-select-node',
  templateUrl: './tree-multi-select-node.component.html',
  styleUrls: ['./tree-multi-select-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeMultiSelectNodeComponent {
  private _displayId: boolean;

  @ObservableInput()
  @Input('disabled')
  private readonly _disabled!: Observable<boolean>;
  defaultedDisabled = this._disabled.pipe(startWith(false));

  @ObservableInput()
  @Input('selected')
  private readonly _selected!: Observable<boolean>;
  defaultedSelected = this._selected.pipe(startWith(false));

  @ObservableInput()
  @Input('autoFocus')
  private readonly _autoFocus!: Observable<boolean>;
  defaultedAutoFocus = this._autoFocus.pipe(startWith(false));

  @ObservableInput()
  @Input('expandable')
  private readonly _expandable!: Observable<boolean>;
  defaultedExpandable = this._expandable.pipe(startWith(false));

  @ObservableInput()
  @Input('expanded')
  private readonly _expanded!: Observable<boolean>;
  defaultedExpanded = this._expanded.pipe(startWith(false));

  @ObservableInput()
  @Input('indeterminate')
  private readonly _indeterminate!: Observable<boolean>;
  defaultedIndeterminate = this._indeterminate.pipe(startWith(false));

  @ObservableInput()
  @Input('subvertBox')
  private readonly _subvertBox!: Observable<boolean>;
  subvertBox = this._subvertBox.pipe(startWith(false));

  @ObservableInput()
  @Input('subvertText')
  private readonly _subvertText!: Observable<string>;
  subvertText = this._subvertText.pipe(startWith(undefined));

  @ObservableInput()
  @Input('count')
  private readonly _count!: Observable<number | null>;
  defaultedCount = this._count.pipe(startWith(null));

  @ObservableInput()
  @Input('subtitle')
  private readonly _subtitle!: Observable<string>;
  defaultedSubtitle = this._subtitle.pipe(startWith(null));

  @ObservableInput()
  @Input('subtitleHighlightIndices')
  private readonly _subtitleHighlightIndices!: Observable<string>;
  defaultedSubtitleHighlightIndices = this._subtitleHighlightIndices.pipe(
    startWith([]),
  );

  @ObservableInput()
  @Input('title')
  private readonly _title!: Observable<string>;
  defaultedTitle = this._title.pipe(startWith(null));

  @ObservableInput()
  @Input('titleHighlightIndices')
  private readonly _titleHighlightIndices!: Observable<string>;
  defaultedTitleHighlightIndices = this._titleHighlightIndices.pipe(
    startWith([]),
  );

  @ObservableInput()
  @Input('identifier')
  private readonly _identifier!: Observable<string>;
  defaultedIdentifier = this._identifier.pipe(startWith(null));

  @Input('link') link: TreeLink | null = null;

  @Input()
  get displayId(): boolean {
    return this._displayId;
  }
  set displayId(displayId: boolean) {
    this._displayId = displayId || false;
  }

  @Output() expandedChange = new EventEmitter<void>();
  @Output() selectedChange = new EventEmitter<boolean>();
}
